module.exports = __webpack_public_path__ + "img/Independence Day.d4bc02d7.jpeg";